"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MapboxPitchToggleControl = /*#__PURE__*/function () {
  function MapboxPitchToggleControl(options) {
    _classCallCheck(this, MapboxPitchToggleControl);

    this._pitch = options.pitch || 70;
    this._bearing = options.bearing || null;
    this._minpitchzoom = options.minpitchzoom || null;
  }

  _createClass(MapboxPitchToggleControl, [{
    key: "onAdd",
    value: function onAdd(map) {
      this._map = map;

      var _this = this;

      this._btn = document.createElement('button');
      this._btn.className = 'mapboxgl-ctrl-icon mapboxgl-ctrl-pitchtoggle-3d';
      this._btn.type = 'button';
      this._btn['aria-label'] = 'Toggle Pitch';

      this._btn.onclick = function () {
        if (map.getPitch() === 0) {
          var options = {
            pitch: _this._pitch,
            bearing: 0,
            zoom: map.getZoom()
          };

          if (!_this._bearing) {
            options.bearing = map.getBearing();
          } else {
            options.bearing = _this._bearing;
          }

          if (_this._minpitchzoom && map.getZoom() > _this._minpitchzoom) {
            options.zoom = _this._minpitchzoom;
          }

          map.easeTo(options);
          _this._btn.className = 'mapboxgl-ctrl-icon mapboxgl-ctrl-pitchtoggle-2d';
        } else {
          map.easeTo({
            pitch: 0,
            bearing: map.getBearing()
          });
          _this._btn.className = 'mapboxgl-ctrl-icon mapboxgl-ctrl-pitchtoggle-3d';
        }
      };

      this._map.on('pitchend', function () {
        if (!_this._map) {
          return;
        }

        ;

        if (_this._map.getPitch() === 0) {
          _this._btn.className = 'mapboxgl-ctrl-icon mapboxgl-ctrl-pitchtoggle-3d';
        } else {
          _this._btn.className = 'mapboxgl-ctrl-icon mapboxgl-ctrl-pitchtoggle-2d';
        }
      });

      this._container = document.createElement('div');
      this._container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';

      this._container.appendChild(this._btn);

      return this._container;
    }
  }, {
    key: "onRemove",
    value: function onRemove() {
      if (!this._container || !this._container.parentNode || !this._map) {
        return;
      }

      this._container.parentNode.removeChild(this._container);

      this._map = undefined;
    }
  }]);

  return MapboxPitchToggleControl;
}();

exports.default = MapboxPitchToggleControl;